import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "react-oidc-context";
import { REACT_APP_COGNITO_AUTHORITY, REACT_APP_COGNITO_CLIENT_ID, REACT_APP_HOST } from './Config';

const cognitoAuthConfig = {
  authority: REACT_APP_COGNITO_AUTHORITY,
  client_id: REACT_APP_COGNITO_CLIENT_ID,  
  redirect_uri: `${REACT_APP_HOST}/oauth2/idpresponse`,
  response_type: "code",
  scope: "email openid",
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
